export default __webpack_public_path__ + "static/media/overviewBg@2x.adeb18e0.png";